import {Component, ElementRef, HostListener, inject, input, model, viewChild} from '@angular/core';

@Component({
  selector: 'wun-drawer',
  standalone: true,
  imports: [],
  templateUrl: './drawer.component.html',
  styleUrl: './drawer.component.scss'
})
export class DrawerComponent {

  private readonly el = inject(ElementRef)
  private readonly drawer = viewChild<ElementRef<HTMLElement>>('drawer')
  opened = model.required<boolean>();
  position = input<'left' | 'right'>('left');

  @HostListener("window:click", ['$event'])
  windowClick(event: MouseEvent): void {
    if(this.drawer()?.nativeElement?.contains(<HTMLElement>event.target)) return;

    this.opened.set(false)
  }
}
